import useRequest from "@/lib/request/useRequest";
import { FieldConfig } from "@/types/fieldConfig";
import {
    Button,
    ModalContent,
    ModalBody,
    ModalHeader,
    Modal,
    ModalFooter,
    Checkbox,
} from "@heroui/react";
import { useState, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckDouble } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

function BulkConfirmPlots({
    selectedFields,
    onFinish,
}: {
    selectedFields: FieldConfig[];
    onFinish: () => void;
}) {
    const { useMutateRequest } = useRequest();

    const { t } = useTranslation("insights");

    const [plotsConfirmed, setPlotsConfirmed] = useState(false);

    const bulkConfirmPlotsMutation = useMutateRequest({
        url: "application_operations/confirm_plots/",
        method: "put",
        successMessage: "Plots confirmed.",
        errorMessage: "Failed to confirm plots.",
    });

    const handleConfirmPlots = useCallback(() => {
        const applicationIds = selectedFields.map(
            (field) => field.latest_prescription_application,
        );
        bulkConfirmPlotsMutation.mutate(
            {
                data: { application_ids: applicationIds },
            },
            {
                onSuccess: () => {
                    onFinish();
                },
            },
        );
    }, [bulkConfirmPlotsMutation, onFinish, selectedFields]);

    return (
        <Modal isOpen={true} onClose={onFinish}>
            <ModalContent>
                <ModalHeader>Confirm Plots</ModalHeader>
                <ModalBody>
                    <Checkbox
                        isSelected={plotsConfirmed}
                        onValueChange={setPlotsConfirmed}
                    >
                        {t("confirmPlotsAccurate")}
                    </Checkbox>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="primary"
                        startContent={<FontAwesomeIcon icon={faCheckDouble} />}
                        onPress={handleConfirmPlots}
                        isDisabled={!plotsConfirmed}
                        fullWidth
                    >
                        Confirm Plots
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}

export default BulkConfirmPlots;
